var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C9.13333 20 7.84167 19.7375 6.625 19.2125C5.40833 18.6875 4.34583 17.9708 3.4375 17.0625C2.52917 16.1542 1.8125 15.0917 1.2875 13.875C0.7625 12.6583 0.5 11.3667 0.5 10C0.5 8.61667 0.7625 7.32083 1.2875 6.1125C1.8125 4.90417 2.52917 3.84583 3.4375 2.9375C4.34583 2.02917 5.40833 1.3125 6.625 0.7875C7.84167 0.2625 9.13333 0 10.5 0C10.7833 0 11.0208 0.0958333 11.2125 0.2875C11.4042 0.479167 11.5 0.716667 11.5 1C11.5 1.28333 11.4042 1.52083 11.2125 1.7125C11.0208 1.90417 10.7833 2 10.5 2C8.28333 2 6.39583 2.77917 4.8375 4.3375C3.27917 5.89583 2.5 7.78333 2.5 10C2.5 12.2167 3.27917 14.1042 4.8375 15.6625C6.39583 17.2208 8.28333 18 10.5 18C12.7167 18 14.6042 17.2208 16.1625 15.6625C17.7208 14.1042 18.5 12.2167 18.5 10C18.5 9.71667 18.5958 9.47917 18.7875 9.2875C18.9792 9.09583 19.2167 9 19.5 9C19.7833 9 20.0208 9.09583 20.2125 9.2875C20.4042 9.47917 20.5 9.71667 20.5 10C20.5 11.3667 20.2375 12.6583 19.7125 13.875C19.1875 15.0917 18.4708 16.1542 17.5625 17.0625C16.6542 17.9708 15.5958 18.6875 14.3875 19.2125C13.1792 19.7375 11.8833 20 10.5 20Z",
    fill: "#282930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressActivity);
export default __webpack_public_path__ + "static/media/progress-activity.9abf838e0c87127f49cc95fa63508d0f.svg";
export { ForwardRef as ReactComponent };